<template>
  <div class="page-title-box">
    <div class="row align-items-center">
      <div class="col-sm-6">
        <!-- <h4 class="page-title">Departamento: {{ departamento.dep_name }}</h4> -->
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-right">
          <li class="breadcrumb-item">
            <router-link to="/">Inicio</router-link>
          </li>
          <li class="breadcrumb-item">Estudante</li>
          <li class="breadcrumb-item active">Perfil</li>
        </ol>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="card">
        <div class="row">
          <div class="col-md-4">
            <div class="card-header">
              <h3 class="card-title">Perfil pessoal</h3>
            </div>
            <div class="card-body">
              <br />

              <ul class="list-unstyled" v-if="person != null">
                <li class="mb-2">
                  <h4 class="">{{ person.fullName }}</h4>
                  <small class="text-center">{{ person.email }}</small>
                </li>
                <li class="mb-2">
                  <strong class="">Bilhete de Identidade: </strong
                  ><span class="">{{ person.doc_number }}</span>
                </li>
                <li class="mb-2">
                  <strong class="">Data de Nascimento: </strong
                  ><span class="">{{ person.birthDate }}</span>
                </li>
                <li class="mb-2">
                  <strong class="">Endere&ccedil;o: </strong
                  ><span class="">{{ person.address_location }}</span>
                </li>
                <li class="mb-2">
                  <strong class="">G&eacute;nero: </strong
                  ><span class="">{{ person.gender }}</span>
                </li>
                <li class="mb-2">
                  <strong class="">Formado na (o): </strong
                  ><span class="">{{ person.last_school_frequency }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-8">
            <div class="card-header">
              <h3 class="card-title">Informa&ccedil;&otilde;es adicionais</h3>
            </div>
            <div class="card-body">
              <br />
              <ul class="list-unstyled" v-if="person != null">
                <li class="mb-2">
                  <strong class="">Nome da Turma: </strong
                  ><span class="">{{ person.classmate_name }} </span>
                </li>
                <li class="mb-2">
                  <strong class="">Regime: </strong
                  ><span class=""> {{ person.classmate_scholar_shift }}</span>
                </li>

                <li class="mb-2">
                  <strong class="">Curso: </strong
                  ><span class=""> {{ person.course_name }}</span>
                </li>
                <li class="mb-2">
                  <strong class="">Nivel: </strong
                  ><span class=""> {{ person.classmate_level_name }}</span>
                </li>
                <li class="mb-2">
                  <strong class="">Ano de Turma: </strong
                  ><span class=""> </span>
                </li>
              </ul>
              <!-- <table class="table">
                <tr>
                  <th style="width:20%">Disciplinas que leciona</th>
                  <td>
                    <span class="justify-content-between">
                     </span> 
                  </td>
                </tr>
                <tr>
                  <th>Turmas alocadas</th>
                  <td>
                    <span class="justify-content-between">
                      
                     
                    </span>
                  </td>
                </tr>
               
                
              </table> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal para update do novo estudante -->
  <div id="modal-overlay" v-show="isModalAddNewDept">
    <div class="container mt-2 pb-3 bg-white">
      <div class="modal-header">
        <h5 class="modal-title">Definir uma nova senha</h5>
      </div>
      <div class="modal-body">
        <div class="pt-3">
          <div class="settings-form">
            <h4 class="text-primary">Actualizar a Senha</h4>
            <form @submit.prevent="submitForm">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Senha Actual</label>
                  <div class="input-group-append">
                    <input
                      v-model="formData.senha_actual"
                      :type="showPassword ? 'text' : 'password'"
                      placeholder="Senha Actual"
                      class="form-control"
                    />
                    <span class="p-viewer" @click="showPasswordClick">
                      <i
                        v-if="showPassword == true"
                        class="fa fa-eye"
                        aria-hidden="true"
                      >
                      </i>
                      <i v-else class="fa fa-eye-slash" aria-hidden="true"> </i>
                    </span>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label>Nova Senha</label>
                  <div class="input-group-append">
                    <input
                      v-model="formData.nova_senha"
                      :type="showPasswordNew ? 'text' : 'password'"
                      placeholder="Nova Senha"
                      class="form-control"
                      @input="validatePassword"
                    />
                    <span class="p-viewer" @click="showPasswordClickNew">
                      <i
                        v-if="showPasswordNew == true"
                        class="fa fa-eye"
                        aria-hidden="true"
                      >
                      </i>
                      <i v-else class="fa fa-eye-slash" aria-hidden="true"> </i>
                    </span>
                  </div>
                </div>
                <p v-if="passwordError" style="color: red; font-size: 11px">
                  {{ passwordError }}
                </p>
              </div>
              <div class="form-group">
                <label>Confirmar Senha</label>
                <div class="input-group-append">
                  <input
                    v-model="formData.confirmar_senha"
                    :type="showPasswordConf ? 'text' : 'password'"
                    placeholder="Confirmar Senha"
                    class="form-control"
                  />
                  <span class="p-viewer" @click="showConfPasswordClick">
                    <i
                      v-if="showPasswordConf == true"
                      class="fa fa-eye"
                      aria-hidden="true"
                    >
                    </i>
                    <i v-else class="fa fa-eye-slash" aria-hidden="true"> </i>
                  </span>
                </div>
              </div>
              <p v-if="passwordConfirm" style="color: red; font-size: 11px">
                {{ passwordConfirm }}
              </p>

              <button
                class="btn btn-primary float-right"
                :disabled="loading"
                type="submit"
              >
                Actualizar
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Loading :loadingData="loading"></Loading>
</template>
<script setup>
import { onMounted, ref } from "vue";
import StudentStoreModule from "./StudentStoreModule";
import Loading from "@/components/Loading.vue";
import store from "@/store";
import passwordStoreModule from "../login/passwordStoreModule";
import { usePercentages } from "@/store/usePercentages";
import { toast } from "vue3-toastify";

const usePercentage = usePercentages();
const person = ref(null);
const loading = ref(false);
const formData = ref({
  senha_actual: "",
  nova_senha: "",
  confirmar_senha: "",
});
const passwordError = ref("");
const passwordConfirm = ref("");
const passwordValid = ref(false);
const isModalAddNewDept = ref(false);
const showPassword = ref(false);
const showPasswordConf = ref(false);
const showPasswordNew = ref(false);

function showPasswordClick() {
  if (formData.value.senha_actual == "") {
    return toast.info("por favor informe senha", {
      autoClose: 1000,
    });
  }
  showPassword.value = !showPassword.value;
}

function showPasswordClickNew() {
  if (formData.value.nova_senha == "") {
    return toast.info("por favor informe nova senha", {
      autoClose: 1000,
    });
  }
  showPasswordNew.value = !showPasswordNew.value;
}

function showConfPasswordClick() {
  if (formData.value.confirmar_senha == "") {
    return toast.info("por favor informe senha", {
      autoClose: 1000,
    });
  }
  showPasswordConf.value = !showPasswordConf.value;
}
async function getStudentProfile() {
  try {
    loading.value = true;

    const [respProfile, totalCommunication, communications] = await Promise.all(
      [
        StudentStoreModule.actions.getMyDatas(),
        StudentStoreModule.actions.totalCommunication(),
        StudentStoreModule.actions.communications(),
      ]
    );
    if (respProfile.data[0]?.first_logg === "yes") {
      isModalAddNewDept.value = true;
    }

    localStorage.setItem("myProfile", JSON.stringify(respProfile.data[0]));
    localStorage.setItem(
      "myNotifications",
      JSON.stringify(communications.data.data)
    );
    store.dispatch(
      "student/setTotalCommunications",
      totalCommunication.data.totalCommunications
    );

    console.log("====================================");
    console.log(respProfile.data);
    console.log("====================================");
    person.value = respProfile.data[0];
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

async function submitForm() {
  try {
    loading.value = true;
    if (formData.value.senha_actual == "") {
      loading.value = false;

      toast.info("Por favor preencha o campo senha actual", {
        autoClose: 1000,
      });
      return;
    }
    if (formData.value.nova_senha == "") {
      loading.value = false;

      toast.info("Por favor preencha o campo nova senha", {
        autoClose: 1000,
      });
      return;
    }
    if (formData.value.nova_senha == "") {
      loading.value = false;

      toast.info("Por favor preencha o campo confirmar senha", {
        autoClose: 1000,
      });
      return;
    }

    if (formData.value.confirmar_senha != formData.value.nova_senha) {
      formData.value = "Por favor confirme a senha";
    }
    const resp = await passwordStoreModule.actions.updatePassword({
      senha_actual: formData.value.senha_actual,
      nova_senha: formData.value.nova_senha,
      confirmar_senha: formData.value.confirmar_senha,
    });

    if (resp.data == 1) {
      toast.success("Senha actualizada com sucesso", {
        autoClose: 1000,
      });
      formData.value.senha_actual = "";
      formData.value.nova_senha = "";
      formData.value.confirmar_senha = "";
      isModalAddNewDept.value = false;
    } else {
      toast.info(resp.data.message, {
        autoClose: 1000,
      });
    }
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

function validatePassword() {
  // Requisitos mínimos de segurança
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(formData.value.nova_senha);
  const hasLowerCase = /[a-z]/.test(formData.value.nova_senha);
  const hasDigit = /\d/.test(formData.value.nova_senha);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(
    formData.value.nova_senha
  );

  // Verifica se a senha atende aos critérios
  if (
    formData.value.nova_senha.length < minLength ||
    !hasUpperCase ||
    !hasLowerCase ||
    !hasDigit ||
    !hasSpecialChar
  ) {
    if (formData.value.nova_senha !== "") {
      passwordError.value =
        "A senha deve ter pelo menos 8 caracteres, incluindo maiúsculas, minúsculas, números e caracteres especiais.";
    }
  } else {
    passwordValid.value = true;
    passwordError.value = null;
  }

  if (formData.value.nova_senha == "") {
    passwordError.value = null;
  }
}
onMounted(() => {
  getStudentProfile();
  usePercentage.fetchPercentages();
});
</script>

<style scope>
.bg-card-class {
  background-color: #1a1c2a;
  border-radius: 6px;
}

.bg-card-class span.fa.fa-times {
  cursor: pointer;
}

.password-input-group .input-wrapper {
  position: relative;
  display: flex;
  width: 100%;
}

.p-viewer,
.p-viewer2 {
  margin-left: -20px;
  margin-top: 10px;
  position: relative;
  z-index: 1;
  cursor: pointer;
}
</style>